import { fontSize, fontWeight, lineHeight } from "../../../../../constants/typography";
import styled from 'styled-components';
import { colors } from "../../../constants";
export var Link = styled.a.withConfig({
  componentId: "sc-bgpk9t-0"
})(["color:", ";display:block;font-size:", ";font-weight:", ";line-height:", ";"], function (_ref) {
  var palette = _ref.palette;
  return colors[palette];
}, fontSize.small, fontWeight.regular, lineHeight.large);
export var Inner = styled.span.withConfig({
  componentId: "sc-bgpk9t-1"
})(["transition:transform 0.2s ease-in;display:block;&:hover{transform:translateX(8px);}"]);